import React, { Component } from 'react'
import {
  Card,
  Divider,
  Header,
  Icon,
  List,
  Grid,
  GridColumn,
  GridRow,
  CardContent,
  CardHeader,
  CardDescription,
  Menu
} from 'semantic-ui-react'
import './HelpScreen.css'

class HelpScreen extends Component {
  render () {
    return (
      <>
        <Header as='h1' dividing>Aide</Header>
        <Grid>
          <GridColumn width={3}>
            <Header as='h2'>Menu</Header>
            <Menu text vertical>
              <Menu.Item header>Client</Menu.Item>
              <Menu.Item
                name='Liste de clients'
                href='#client-index'
              />
              <Menu.Item
                name='Créer ou modifier un client'
                href='#client-add'
              />
              <Menu.Item
                name='Importation de clients'
                href='#client-import'
              />
              <Menu.Item
                href='#client-adresses'
              >
                Adresses d'inspections
              </Menu.Item>
              <Menu.Item
                href='#client-equipment'
              >
                Liste d'équipements
              </Menu.Item>
              <Divider />
              <Menu.Item header>Calendrier</Menu.Item>
              <Menu.Item
                name='Limiter les accès'
                href='#calendrier-roles'
              />
              <Menu.Item
                name='Les couleurs utilisées'
                href='#calendrier-couleurs'
              />
              <Divider />
              <Menu.Item header>Inspection</Menu.Item>
              <Menu.Item
                name='Planifier un rendez-vous'
                href='#inspection-create'
              />
              <Menu.Item
                href='#inspection-edit'
              >
                Remplir le formulaire d'inspection
              </Menu.Item>
              <Menu.Item
                name='Valider un formulaire'
                href='#inspection-submit'
              />
              <Divider />
              <Menu.Item header>Archive</Menu.Item>
              <Divider />
              <Menu.Item header>Courriel</Menu.Item>
            </Menu>
          </GridColumn>
          <GridColumn width={13}>
            <Grid>
              <GridRow>
                <GridColumn>
                  <Header as='h1'>Section client</Header>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='client-import' as='h2'>Liste de clients</Header>
                  <p>Il faut au minimum un des deux rôles nécessaire afin d'avoir accès au menu
                    client. Lecture limitée filtrera la liste selon les équipements sélectionnés
                    dans le compte utilisateur.
                    Lorsque vous cliquez sur un client, vous allez accéder à tous les informations
                    relié à celui-ci. Le calendrier dans la page du client affichera seulement les
                    inspections associées.
                    Cette page permet aussi de voir et gérer les adresses et équipements du
                    client
                  </p>
                  <p>Les actions disponibles à partir de la liste de clients sont:<br />
                    <a href='#client-edit'><Icon name='pencil' /> pour modifier les informations de
                      base du client
                    </a><br />
                    <a href='#client-adresses'><Icon name='briefcase' /> pour afficher les adresses
                      d'inspection
                    </a><br />
                    <a href='#inspection-create'><Icon name='file' /> Planifier une
                      inspection
                    </a><br />
                    <a href='#inspection-create'><Icon name='magnify' /> pour afficher les
                      inspections planifiées du client
                    </a>
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Lecture tous</List.Item>
                          <List.Item>Lecture limitée</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='client-add' as='h2'>Créer ou modifier un client</Header>
                  <p>
                    Les informations de base du client lors de la création ou modification de base
                    est relié au nom de la compagnie et les informations de facturation.<br />
                    Le courriel sera nécessaire si vous voulez envoyer des notifications
                    d'inspection automatique au client!
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Création</List.Item>
                          <List.Item>Modification</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='client-import' as='h2'>Importation de clients à partir de
                    ServiCentre
                  </Header>
                  <p>
                    Pour importer un nouveau client, il faut cliquer sous le menu client et le
                    bouton "Liste de clients ServiCentre".
                    Les clients affiché sont dans une table temporaire, le principle est de ne pas
                    tous les ajouter directement dans la table de clients principaux afin de filtrer
                    et garder seulement les nécessaires.
                    Cette liste de client est synchronisé chaque 10 minutes et si un client est
                    importé dans la liste de clients principaux, celui-ci sera aussi
                    synchronisé.<br />
                    *Il sera important de vérifier que le client possède bien un courriel afin de le
                    notifier lorsqu'une inspection est terminé!
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Création</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='client-adresses' as='h2'>Adresses d'inspections</Header>
                  <p>
                    Cette page est accessible à partir de la liste de clients ou dans la
                    visualisation d'un client.<br />
                    Il est possible d'ajouter une adresse d'inspection à partir de cette page.
                    L'adresse doit être créée avant de pouvoir associer un ou des équipements à
                    celui-ci.<br />
                    Les actions disponibles à partir de la liste de clients sont:<br />
                    <a href='#client-adresse'><i className='mdi mdi-pencil-outline' /> pour modifier
                      les informations de l'adresse
                    </a><br />
                    <a href='#client-equipment'><i className='mdi mdi-briefcase' /> pour modifier les
                      équipements et formulaire de l'adresse
                    </a><br />
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Lecture tous</List.Item>
                          <List.Item>Lecture limitée</List.Item>
                          <List.Item>Creation</List.Item>
                          <List.Item>Modification</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='client-equipment' as='h2'>Liste d'équipements</Header>
                  <p>
                    Lorsque l'adresse d'inspection est créée, vous pouvez ajouter un ou plusieurs
                    équipements reliés à l'adresse.
                    Vous devez en premier choisir l'équipement désiré et par la suite, la liste de
                    formulaires ce mettrera à jour selon l'équipement sélectionné.<br />
                    Dans la liste de formulaires, il est possible d'en sélectionner plusieurs en
                    tenant la touche Ctrl enfoncé et en cliquant sur ceux que vous voulez.<br />
                    La fréquence d'inspection est nécessaire afin de créer la prochaine inspection,
                    le tout expliqué dans la section
                    <a href='#inspection-create'>Planifier un rendez-vous.</a>
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Lecture tous</List.Item>
                          <List.Item>Lecture limitée</List.Item>
                          <List.Item>Creation</List.Item>
                          <List.Item>Modification</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn>
                  <Header as='h1'>Calendrier</Header>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='calendrier-roles' as='h2'>Limiter les accès</Header>
                  <p>
                    La page du calendrier fonctionne avec trois rôles possible. Lecture tous n'a
                    aucune restriction en place, cela permet de voir toutes les inspections du
                    système.
                    Le rôle "lecture limité", limite à les inspections aillant le même équipement
                    que ceux de la liste de l'utilisateur connecté. Le rôle "Lecture propriétaire"
                    est utilisé pour les inspecteurs,
                    c'est-à-dire que le calendrier affichera seulement les inspections associées au
                    technicien.<br />
                    Lorsque vous cliquez sur un événement, une description affichera à la droite du
                    calendrier.
                    Les informations affiché seron l'adresse, l'heure d'inspection, l'équipement, le
                    formulaire, le technicien et l'état de l'inspection.
                    Selon le rôle de l'utilisateur connecté et le statut, il y aura des raccourcis
                    générés afin de faciliter la gestion de l'inspection.
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Lecture tous</List.Item>
                          <List.Item>Lecture limitée</List.Item>
                          <List.Item>Lecture propriétaire</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='calendrier-couleurs' as='h2'>Les couleurs utilisées</Header>
                  <p>
                    La charte de couleur utilisé est:
                  </p>
                  <div className='cube-group'>
                    <div className='cube cube-created' />
                    <label className='cube-label'>En attente d'inspection</label>
                  </div>
                  <div className='cube-group'>
                    <div className='cube cube-expired' />
                    <label className='cube-label'>En retard</label>
                  </div>
                  <div className='cube-group'>
                    <div className='cube cube-started' />
                    <label className='cube-label'>Inspection en cours</label>
                  </div>
                  <div className='cube-group'>
                    <div className='cube cube-waiting' />
                    <label className='cube-label'>En attente d'évaluation</label>
                  </div>
                  <div className='cube-group'>
                    <div className='cube cube-completed' />
                    <label className='cube-label'>Complété</label>
                  </div>
                  <div className='cube-group'>
                    <div className='cube cube-scheduled' />
                    <label className='cube-label'>Planifié, non confirmé</label>
                  </div>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn>
                  <Header as='h1'>Inspection</Header>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='inspection-create' as='h2'>Planifier un rendez-vous</Header>
                  <p>
                    Il y a quelques prérequis nécessaires, le client doit avoir au minimum une
                    adresse avec un équipement et des formulaires.
                    La fréquence d'inspection est importante, car lors de la création d'une
                    inspection, le système va pré allouer la réservation de la prochaine inspection.<br />
                    Tant que le formulaire d'inspection n'est pas commencé, il est possible de
                    déplacer ou changer l'inspecteur associé à celui-ci.<br />
                    Un inspection peut être créer à partir de plusieurs place, en cliquant sur
                    l'icone <Icon name='file' /> à partir de la liste de clients ou lorsque vous
                    visualiser un client,
                    vous avez un bouton "Ajouter une inspection" sous l'adresse.<br />
                    Lorsque vous cliquez sur l'ajout d'inspection, vous allez passer à une nouvelle
                    page permettant de choisir l'équipement désiré sous la bonne adresse.
                    Pour passez à la prochaine étape, vous n'avez qu'à cliquer sur
                    "Sélectionner"<br />
                    Vous devriez maintenant avoir une liste d'employés avec un calendrier.
                    Les employés affichés doivent, au minimum, avoir le même équipement et faire
                    parti d'un rôle qui possède la section "Inspection" avec l'accès "Lecture
                    propriétaire".
                    Le rôle Inspecteur contient déjà les rôles nécessaires, mais il serait possible
                    de créer un rôle différent avec les permissions d'associer un inspection aux
                    utilisateurs du groupe.<br />
                    <br />
                    Lorsque vous choisissez un employé, le calendrier va ce mettre à jour avec les
                    inspections déjà planifié à l'employé.
                    Par la suite, vous n'avez qu'à sélectionner la plage d'horaire désiré dans le
                    calendrier en cliquant et glissant la souris.
                    Pour modifier la sélection, vous pouvez cliquer sur la plage sélectionné et vous
                    allez recevoir une confirmation de suppression.
                    Il est aussi possible de sélectionner une nouvelle plage et l'ancienne sera
                    effacé.<br />
                    Avant de cliquer sur Enregistrer, vous pouvez confirmé la réservation sous
                    "Sélection courante" au dessus du bouton enregistré.<br />
                    <br />
                    La réservation devrait maintenant être disponible sous la section "Calendrier"
                    avec le statut "En attente d'inspection".
                    Il est aussi possible d'avoir la liste de réservation pour un client spécifique.
                    À partir de la liste de clients vous avez l'icone <Icon name='magnify' /> ou si
                    vous cliquez sur un client pour le visualiser,
                    vous allez avoir dans le sous menu en haut de la plage "Liste d'inspections
                    planifiées".
                    Sous cette page vous aller voir les inspections planifiées non commencées et non
                    confirmées.<br />
                    Les actions disponibles dans cette page sont:<br />
                    <Icon name='check' /> pour confirmé une inspection non confirmée<br />
                    <Icon name='pencil' /> pour modifier la date ou l'inspecteur associé<br />
                    <Icon name='trash' /> pour effacé l'inspection planifiée
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Création</List.Item>
                          <List.Item>Modification</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='inspection-edit' as='h2'>Remplir le formulaire d'inspection</Header>
                  <p>
                    Un formulaire peut être commencé en tout temps. Il est important d'enregistrer
                    votre formulaire avant de changer de page,
                    la sauvegarde automatique se fait seulement lorsque vous sélectionnez un autre
                    formulaire ou lorsque vous cliquez sur enregistrer.<br />
                    Lorsque vous cliquez sur "Enregistrer et soumettre" le système va valider les
                    champs requis et vous redirigé au formulaire contenant une erreur s'il y en a
                    une.
                    Sinon vous allez arriver à la page de confirmation de soumissions. Lorsque
                    confirmé, l'inspection tombera en attente d'évaluation.
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Modification</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={13}>
                  <Header id='inspection-submit' as='h2'>Valider un formulaire</Header>
                  <p>
                    Lorsque le formulaire est en attente d'évaluation, un utilisateur avec les rôles
                    nécessaire pourra faire une révision du rapport,
                    apporter des modifications au besoin et complété l'inspection.
                    À ce point, un courriel sera envoyé au client en lui informant que le rapport
                    est disponible avec les informations nécessaires pour visualiser le rapport.
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <Card>
                    <CardContent>
                      <CardHeader>Rôle requis</CardHeader>
                      <CardDescription>
                        <List>
                          <List.Item>Modification</List.Item>
                          <List.Item>Lecture tous</List.Item>
                          <List.Item>Lecture limitée</List.Item>
                        </List>
                      </CardDescription>
                    </CardContent>
                  </Card>
                </GridColumn>
              </GridRow>
            </Grid>
          </GridColumn>
        </Grid>
      </>
    )
  }
}

export default HelpScreen
